import {GenericItemsForm, GenericItemsUtils, IGetAllParams, MuiIcons} from "@leap4/frontend";
import {baseBackendRoute} from "../../../config/generals";
import React from "react";

const { Groups } = MuiIcons;

const fields = {name: 1, isActive: 1,  updated: 1, created: 1}
const getParams: IGetAllParams = {fields}
const {
    store,
    columns
} = GenericItemsUtils.GenerateDefaultStoreAndColumns({baseUrl: `${baseBackendRoute}/organizations`}, fields, {
    isActive: {},
    created: {},
    name: {editLinkFunc: (id) => `/organizations/${id}`},
    updated: {}
})


const OrganizationsTable = () => {

    return <GenericItemsForm store={store} columns={columns} getAllParams={getParams}
                             breadcrumbs={{
                                 link: "/organizations",
                                 text: "Organizations",
                                 icon: <Groups />
                             }}
                             createButton={{
                                 to: "/organizations/add",
                                 text: "Create Organization"
                             }}
                             tableProps={{ pageSize: 50 }}
    />
}

export {OrganizationsTable}
